import { createApiSlice } from "@common/common-slice/commonSlice";

import { CRUD_SKILL_ASSESSMENT_STATUS } from "@routes";

const apiConfig = [
  {
    name: "createSkillAssessmentStatus",
    method: "post",
    url: CRUD_SKILL_ASSESSMENT_STATUS,
    stateKey: "message",
  },
  {
    name: "getSkillAssessmentStatus",
    method: "get",
    url: CRUD_SKILL_ASSESSMENT_STATUS,
    stateKey: "skillAssessmentStatusData",
  },
  {
    name: "updateSkillAssessmentStatus",
    method: "put",
    url: CRUD_SKILL_ASSESSMENT_STATUS,
    stateKey: "message",
  },
  {
    name: "deleteSkillAssessmentStatus",
    method: "delete",
    url: CRUD_SKILL_ASSESSMENT_STATUS,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    skillAssessmentStatusData: [],
    selectedData: {},
  },

  reducers: {
    rowSelect: (state, action) => {
      state.selectedData =
        action?.payload?.length > 0 ? action.payload[0] : {};
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillAssessmentStatus",
  apiConfig,
  customReducers
);

const skillAssessmentStatusSlice = slice;
export default skillAssessmentStatusSlice.reducer;

export const {
  createSkillAssessmentStatus,
  getSkillAssessmentStatus,
  updateSkillAssessmentStatus,
  deleteSkillAssessmentStatus,
} = thunks;

export const {
  rowSelect,
} = actions;